const TextLintStore = {
  namespaced: true,
  state: () => ({
    lintResults: {},
    itemLintActions: {}
  }),
  mutations: {
    setLintResults (state, { uuid, result }) {
      state.lintResults = { ...state.lintResults, [uuid]: result }
    },
    setItemLintAction (state, { uuid, action }) {
      state.itemLintActions = {
        ...state.itemLintActions,
        [uuid]: action
      }
    },
    deleteItemLintAction (state, { uuid }) {
      const actions = { ...state.itemLintActions }
      delete actions[uuid]
      state.itemLintActions = actions
    },
    deleteItemLintResult (state, { uuid }) {
      const results = { ...state.lintResults }
      delete results[uuid]
      state.lintResults = results
    }
  },
  actions: {
    async executeTextlintAction (context, splitChunk = 15, interval = 10000) {
      const chunkArray = (arr, n) => {
        const chunkLength = Math.max(arr.length / n, 1)
        const chunks = []
        for (let i = 0; i < n; i++) {
          if (chunkLength * (i + 1) <= arr.length) { chunks.push(arr.slice(chunkLength * i, chunkLength * (i + 1))) }
        }
        return chunks
      }
      const preExecuteActions = Object.values(
        context.state.itemLintActions
      ).map((actions) => actions.call())

      const chunks = chunkArray(preExecuteActions, splitChunk)
      for (let i = 0; i < chunks.length; i++) {
        await Promise.all(
          chunks[i].map(async (item) => {
            item.call()
            await new Promise((resolve) =>
              setTimeout(() => {
                resolve()
              }, interval)
            )
          })
        )
      }
    }
  },
  getters: {
    noTargetWordsMessages: (state) => (uuid) => {
      if (!state.lintResults[uuid]) return []

      return state.lintResults[uuid].result
        .filter((result) => typeof result.index !== 'number')
        .map((result) => result.message)
    }
  }
}

export default TextLintStore
